import { ReactElement } from 'react';
import { space } from '@op/opds.tokens';
import { Message } from '@messageformat/react';

const InfoTextBox = (): ReactElement => {
  return (
    <div className="investoracademy-info-text-box-container">
      <div style={{ paddingTop: space.default, paddingBottom: space.default }}>
        <div className="investoracademy-info-text-box-inner-container">
          <p className="investoracademy-info-text-box-number">1</p>
          <p className="opds-styles-v1-text-body-medium" style={{ paddingBottom: 0 }}>
            <Message id="course2.introduction.infobox.info1" />
          </p>
        </div>
        <div className="investoracademy-info-text-box-inner-container">
          <p className="investoracademy-info-text-box-number">2</p>
          <p className="opds-styles-v1-text-body-medium" style={{ paddingBottom: 0 }}>
            <Message id="course2.introduction.infobox.info2" />
          </p>
        </div>
        <div className="investoracademy-info-text-box-inner-container">
          <p className="investoracademy-info-text-box-number">3</p>
          <p className="opds-styles-v1-text-body-medium" style={{ paddingBottom: 0 }}>
            <Message id="course2.introduction.infobox.info3" />
          </p>
        </div>
      </div>
    </div>
  );
};

export default InfoTextBox;
